import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { find, maxBy } from 'lodash-es'
import { useQuery } from '@tanstack/react-query'
import { useModelStore } from '@editorStores'
import { getSlabStiffening } from '@queries'
import { getStoreysForSeismic } from './getStoreysForSeismic'

// Returns the storeys that should be used for the seismic calculationso
// if the upper-most slab is not-stiffening (i.e. a roof composite is applied)
// we expect one storey less for the whole configuration.
const useStoreysForSeismic = () => {
  const { projectId }: { projectId?: string } = useParams()
  const model = useModelStore(state => state.model)

  const { data: slabStiffening } = useQuery({
    queryKey: getSlabStiffening.getKey(projectId),
    queryFn: () => getSlabStiffening.request(projectId),
  })

  const upperMostCeiling = useMemo(() => maxBy(model.slabs, 'storey'), [model.slabs])
  const upperMostCeilingStiffening = useMemo(
    () =>
      find(slabStiffening, {
        element_guid: upperMostCeiling?.guid,
      }),
    [slabStiffening, upperMostCeiling?.guid],
  )

  return useMemo(() => {
    // Memoize the derived array so unrelated rerenders do not trigger form reinitialization.
    return getStoreysForSeismic(model.storey_boundaries, upperMostCeilingStiffening?.stiffening)
  }, [model.storey_boundaries, upperMostCeilingStiffening?.stiffening])
}

export default useStoreysForSeismic
